/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input, InputField, Text, Textarea, TextareaInput, View } from '@gluestack-ui/themed'
import React, { PureComponent } from 'react'
import { Platform, StyleSheet, TextInput } from 'react-native'
import { FormText } from '../../api/Form/types'
import { theme } from '../../theme'
import { Item } from '../NativeBaseLegacy'
import { LabelInput } from './components'
import { FormElementProps } from './types'

class TextFieldClass extends PureComponent<FormElementProps<FormText>> {
  private input: TextInput | null = null

  public focus = () => {
    this.input?.focus()
  }

  public render() {
    const { field, returnKeyType, handleChange, value } = this.props
    const elementId = `${field.id}`

    if (field.constraint.height) {
      const numberOfLines = field.constraint.height / theme.textSize.x2
      let lettersAvailables = -1
      let maxSize = null
      // inputValue === -1 quand il n'y a pas de limite de caractère
      if (value && typeof value === 'string' && value.length && field.constraint.maxSize) {
        lettersAvailables = field.constraint.maxSize ? field.constraint.maxSize - value.length : -1
        maxSize = field.constraint.maxSize as any
      }
      const color = lettersAvailables < 20 && lettersAvailables > 0 ? theme.colors.red : theme.colors.silverStrong
      return (
        <View>
          <View style={styles.titleContainer}>
            <LabelInput text={field.libelle} required={field.constraint.mandatory} />
            <Text style={{ color }}>{lettersAvailables > 0 ? lettersAvailables : null}</Text>
          </View>
          <Textarea style={{ minHeight: field.constraint.height }}>
            <TextareaInput
              ref={(input: any) => (this.input = input)}
              numberOfLines={numberOfLines}
              scrollEnabled
              maxLength={maxSize ?? undefined}
              returnKeyType="default"
              onChangeText={handleChange(elementId)}
              value={value as string}
            />
          </Textarea>
        </View>
      )
    }

    return (
      <View>
        <LabelInput text={field.libelle} required={field.constraint.mandatory} />
        <Item>
          <Input variant="outline">
            <InputField
              ref={(input: any) => (this.input = input)}
              returnKeyType={returnKeyType}
              keyboardType={this.keyboardType}
              onChangeText={handleChange(elementId)}
              value={value as string}
              caretHidden={this.isCaretHidden}
            />
          </Input>
        </Item>
      </View>
    )
  }

  private get isCaretHidden() {
    const { field } = this.props
    if (field.type === 'field_email' && Platform.OS === 'android' && +Platform.Version > 28) {
      return true
    }
    return false
  }

  private get keyboardType() {
    const { field } = this.props
    switch (field.type) {
      case 'field_texte':
        return 'default'
      case 'field_email':
        return 'email-address'
      case 'field_phone':
        return 'phone-pad'
      default:
        return 'default'
    }
  }
}

const styles = StyleSheet.create({
  titleContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  input: {
    borderWidth: 1,
    borderColor: theme.colors.silver,
    borderRadius: 4,
    paddingHorizontal: theme.padding.x2,
    paddingVertical: theme.padding.x1,
    fontSize: theme.textSize.x1_75,
  },
  textArea: {
    borderWidth: 1,
    borderColor: theme.colors.silver,
    borderRadius: 4,
    paddingHorizontal: theme.padding.x2,
    paddingVertical: theme.padding.x1,
    fontSize: theme.textSize.x1_75,
    textAlignVertical: 'top',
  },
})

export const TextField = TextFieldClass
